import { Roles, UserType } from 'infrastructure/enums';

export const trackableRoles = [
  Roles.Doctor,
  Roles.NursePractitioner,
  Roles.PhysicianAssistant,
  Roles.MedicalAssistant,
  Roles.RegisteredNurse,
  Roles.QHCP,
  Roles.PharmD,
];
export const notTrackableRoles = [Roles.Support, Roles.Onboarding];
export const trackableHhaRoles = [
  Roles.Doctor,
  Roles.NursePractitioner,
  Roles.PhysicianAssistant,
  Roles.MedicalAssistant,
  Roles.RegisteredNurse,
  Roles.QHCP,
];
export const ccmTrackableHhaRoles = [
  Roles.PhysicianAssistant,
  Roles.MedicalAssistant,
  Roles.Doctor,
  Roles.QHCP,
  Roles.NursePractitioner,
  Roles.RegisteredNurse,
];
export const readOnlyHhaRoles = [
  Roles.Biller,
  Roles.ClientSuccessOnboarding,
  Roles.SalesRepresentative,
  Roles.ClientSuccessScaling,
];

export const accessRolesMap = {
  [UserType.Admin]: [Roles.Default, Roles.Clinical],
  [UserType.HomeHealth]: [
    ...trackableHhaRoles,
    ...ccmTrackableHhaRoles,
    ...readOnlyHhaRoles,
    Roles.Support,
    Roles.Biller,
  ],
  [UserType.Practice]: [...trackableRoles, ...notTrackableRoles, Roles.Biller],
  [UserType.Patient]: [],
};

// banner
export const carePlanDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...trackableHhaRoles, ...readOnlyHhaRoles],
  [UserType.Practice]: [Roles.Biller],
  [UserType.Patient]: [],
};
export const vitalsReportDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...ccmTrackableHhaRoles, Roles.Support, Roles.Biller],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
export const slaFlagDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...ccmTrackableHhaRoles, Roles.Support, Roles.Biller],
  [UserType.Practice]: [...trackableRoles, ...notTrackableRoles, Roles.Biller],
  [UserType.Patient]: [],
};
export const contactAvailabilityDisableRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...readOnlyHhaRoles],
  [UserType.Practice]: [Roles.Biller],
  [UserType.Patient]: [],
};

// control panel
export const generalCommentsDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...readOnlyHhaRoles],
  [UserType.Practice]: [Roles.Biller],
  [UserType.Patient]: [],
};
export const generalCommentsPrmTabDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...ccmTrackableHhaRoles, Roles.Support, Roles.Biller],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
export const generalCommentsCcmTabDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...trackableHhaRoles, ...readOnlyHhaRoles],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
export const rpmCallAndSmsButtonsDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...ccmTrackableHhaRoles, Roles.Support, Roles.Biller],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
export const ccmCallAndSmsButtonsDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...trackableHhaRoles, ...readOnlyHhaRoles],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
export const createCaseInEHRDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [],
  [UserType.Practice]: [...trackableRoles, ...notTrackableRoles, Roles.Biller],
  [UserType.Patient]: [],
};
export const createCaseInEHRRpmTabDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [
    ...ccmTrackableHhaRoles,
    ...readOnlyHhaRoles,
    Roles.Support,
    Roles.Biller,
  ],
  [UserType.Practice]: [...trackableRoles, ...notTrackableRoles, Roles.Biller],
  [UserType.Patient]: [],
};
export const createCaseInEHRCcmTabDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [
    ...trackableHhaRoles,
    ...readOnlyHhaRoles,
    Roles.Biller,
  ],
  [UserType.Practice]: [...trackableRoles, ...notTrackableRoles, Roles.Biller],
  [UserType.Patient]: [],
};
export const createCaseInEHRDisableRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...trackableHhaRoles, ...readOnlyHhaRoles],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
export const holdingStatusDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...readOnlyHhaRoles, Roles.Biller],
  [UserType.Practice]: [Roles.Biller],
  [UserType.Patient]: [],
};
export const temporaryHoldDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...trackableHhaRoles, ...readOnlyHhaRoles],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
export const awaitingConsumablesDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...ccmTrackableHhaRoles, Roles.Support, Roles.Biller],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
export const requestsButtonDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...ccmTrackableHhaRoles, Roles.Support, Roles.Biller],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
export const criticalEscalationDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...ccmTrackableHhaRoles, Roles.Support, Roles.Biller],
  [UserType.Practice]: [...trackableRoles, ...notTrackableRoles, Roles.Biller],
  [UserType.Patient]: [],
};
export const criticalEscalationDisableRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...readOnlyHhaRoles],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
export const followUpAppointmentDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...trackableHhaRoles, ...readOnlyHhaRoles],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
export const followUpAppointmentDisableRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [Roles.Biller],
  [UserType.Practice]: [Roles.Biller],
  [UserType.Patient]: [],
};

// interaction time
export const interactionTimeRpmDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...ccmTrackableHhaRoles, Roles.Support, Roles.Biller],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
export const interactionTimeCcmDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...trackableHhaRoles, ...readOnlyHhaRoles],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
export const interactionTimeAddTimeRpmDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [
    ...trackableHhaRoles,
    ...ccmTrackableHhaRoles,
    ...readOnlyHhaRoles,
    Roles.Support,
    Roles.Biller,
  ],
  [UserType.Practice]: [Roles.Biller],
  [UserType.Patient]: [],
};
export const interactionTimeAddTimeCcmDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [
    ...trackableHhaRoles,
    ...readOnlyHhaRoles,
    Roles.Support,
    Roles.Biller,
  ],
  [UserType.Practice]: [Roles.Biller],
  [UserType.Patient]: [],
};

// averages
export const averagesDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...ccmTrackableHhaRoles, Roles.Support, Roles.Biller],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};

// past medical history
export const pastMedicalHistoryDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...trackableHhaRoles, ...readOnlyHhaRoles],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
export const addPastMedicalHistoryDisableRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [Roles.Biller],
  [UserType.Practice]: [Roles.Biller],
  [UserType.Patient]: [],
};

// clinical activity and clinical interventions
export const voiceCallRpmDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...ccmTrackableHhaRoles, Roles.Support, Roles.Biller],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
export const voiceCallCcmDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...trackableHhaRoles, ...readOnlyHhaRoles],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
export const smsRpmActivityDenyRolesMap = structuredClone(
  voiceCallRpmDenyRolesMap,
);
export const smsCcmActivityDenyRolesMap = structuredClone(
  voiceCallCcmDenyRolesMap,
);
export const manualClinicalNotesRpmDenyRolesMap = structuredClone(
  voiceCallRpmDenyRolesMap,
);
export const manualClinicalNotesCcmDenyRolesMap = structuredClone(
  voiceCallCcmDenyRolesMap,
);
export const clinicalNotesRpmDenyRolesMap = structuredClone(
  voiceCallRpmDenyRolesMap,
);
export const clinicalNotesCcmDenyRolesMap = structuredClone(
  voiceCallCcmDenyRolesMap,
);
export const addClinicalNotesCcmDisableRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [Roles.Biller],
  [UserType.Practice]: [Roles.Biller],
  [UserType.Patient]: [],
};

// activity
export const activityDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...ccmTrackableHhaRoles, Roles.Support, Roles.Biller],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
export const sendCommentDisableRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...ccmTrackableHhaRoles, ...readOnlyHhaRoles],
  [UserType.Practice]: [Roles.Biller],
  [UserType.Patient]: [],
};
export const reviewDisableRolesMap = structuredClone(
  sendCommentDisableRolesMap,
);
export const aiCommentDisableRolesMap = structuredClone(
  sendCommentDisableRolesMap,
);
export const bookmarkedCommentsDisableRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [
    ...trackableHhaRoles,
    ...ccmTrackableHhaRoles,
    ...readOnlyHhaRoles,
    Roles.Support,
    Roles.Biller,
  ],
  [UserType.Practice]: [Roles.Biller],
  [UserType.Patient]: [],
};
export const bookmarkedCommentsDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [
    ...trackableHhaRoles,
    ...ccmTrackableHhaRoles,
    ...readOnlyHhaRoles,
    Roles.Support,
    Roles.Biller,
  ],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
export const rpmCommentTemplateDisableRolesMap = structuredClone(
  sendCommentDisableRolesMap,
);

// key notes
export const keyNoteRpmTabDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...ccmTrackableHhaRoles, Roles.Support, Roles.Biller],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
export const addEditRpmKeyNoteDisableRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [
    ...ccmTrackableHhaRoles,
    ...readOnlyHhaRoles,
    Roles.Support,
    Roles.Biller,
  ],
  [UserType.Practice]: [Roles.Biller],
  [UserType.Patient]: [],
};
export const keyNoteCcmTabDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...trackableHhaRoles, ...readOnlyHhaRoles],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
export const addEditCcmKeyNoteDisableRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [
    ...trackableHhaRoles,
    ...readOnlyHhaRoles,
    Roles.Biller,
  ],
  [UserType.Practice]: [Roles.Biller],
  [UserType.Patient]: [],
};

// services
export const servicesCcmTabDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...trackableHhaRoles, ...readOnlyHhaRoles],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
export const servicesCcmTabDisableRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [
    ...trackableHhaRoles,
    ...readOnlyHhaRoles,
    Roles.Biller,
  ],
  [UserType.Practice]: [Roles.Biller],
  [UserType.Patient]: [],
};
export const servicesRpmTabDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...ccmTrackableHhaRoles, Roles.Support, Roles.Biller],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};

// medication
export const addMedicationDisabledRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...readOnlyHhaRoles, Roles.Biller],
  [UserType.Practice]: [Roles.Biller],
  [UserType.Patient]: [],
};

// read only roles
export const readOnlyDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...readOnlyHhaRoles, Roles.Biller],
  [UserType.Practice]: [Roles.Biller],
  [UserType.Patient]: [],
};
